import * as types from "../types/index";
import { core } from "./core";

export const getSchedules = () => {
  return core.API(
    "GET",
    `/schedules?limit=200&offset=0`,
    types.GET_SCHEDULES,
    types.GET_SCHEDULES_SUCCESS,
    types.GET_SCHEDULES_FAILURE
  );
};

export const createSchedule = (data) => {
  return core.API(
    "POST",
    `/schedule`,
    types.CREATE_SCHEDULES,
    types.CREATE_SCHEDULES_SUCCESS,
    types.CREATE_SCHEDULES_FAILURE,
    data
  );
};

export const deleteSchedule = (id) => {
  return core.API(
    "DELETE",
    `/schedule/${id}`,
    types.DELETE_SCHEDULES,
    types.DELETE_SCHEDULES_SUCCESS,
    types.DELETE_SCHEDULES_FAILURE
  );
};

export const updateSchedule = (id, data) => {
  return core.API(
    "PUT",
    `/schedule/${id}/`,
    types.PUT_SCHEDULES,
    types.PUT_SCHEDULES_SUCCESS,
    types.PUT_SCHEDULES_FAILURE,
    data
  );
};

export const updateScheduleUsers = (id, data) => {
  return core.API(
    "PUT",
    `/schedule/${id}/update-users`,
    types.PUT_SCHEDULES_USER,
    types.PUT_SCHEDULES_USER_SUCCESS,
    types.PUT_SCHEDULES_USER_FAILURE,
    data
  );
};
